import { initUhsOptions } from 'uhs-options.dom';
import { initMagOffer } from 'uhs-mag-offer.dom';




const root = document.querySelector('[data-uhs-options]');
let ctx;
if (root) {
  try {
    ctx = initUhsOptions(root);
  } catch (err) {
    console.error('UHS init failed:', err);
    const errEl = root.querySelector('[data-uhs-errors]');
    if (errEl) {
      errEl.textContent = 'Product options failed to load. Please refresh the page. If the issue persists, contact Upper Hand Holsters.';
    }
  }
}


const offerRoot = root?.querySelector('[data-uhs-mag-offer]');
if (ctx && offerRoot) {
  try {
    initMagOffer(offerRoot, ctx);
  } catch (err) {
    console.error('UHS mag offer init failed:', err);
    offerRoot.hidden = true;
  }
}


if (ctx) {
  import('uhs-options.rts')
    .then(({ initRtsOffer }) => initRtsOffer(ctx))
    .catch(err => console.error('UHS ready-to-ship offer init failed:', err));
}
